"use client";

import { Box, useTheme } from "@mui/material";
import { keyframes } from "@mui/system";
import { ColorSchema } from "@rmh/ui-config/src/colorToken";

type LoadingDotsProps = {
  size?: number; // px width
  color?: string; // any CSS color (defaults to currentColor)
  theme?: "light" | "dark";
};

const l3 = keyframes`
  20% { background-position: 0%   0%, 50%  50%, 100%  50% }
  40% { background-position: 0% 100%, 50%   0%, 100%  50% }
  60% { background-position: 0%  50%, 50% 100%, 100%   0% }
  80% { background-position: 0%  50%, 50%  50%, 100% 100% }
`;

export function LoadingDots({
  size = 60,
  color = "currentColor",
  theme = "light",
}: LoadingDotsProps) {
  const muiTheme = useTheme();
  let loaderColor = muiTheme.palette.secondary.contrastText;

  if (theme) {
    if (theme === "dark") {
      loaderColor = ColorSchema.dark.secondary.contrastText || color;
    } else {
      loaderColor = ColorSchema.light.secondary.contrastText || color;
    }
  }

  if (color) {
    loaderColor = color;
  }

  return (
    <Box
      data-cy="loading_dots"
      sx={{
        display: "inline-block",
        width: size,
        aspectRatio: "2",
        "--_g": `no-repeat radial-gradient(circle closest-side, ${loaderColor} 90%, #0000)`,
        background: `
          var(--_g) 0%   50%,
          var(--_g) 50%  50%,
          var(--_g) 100% 50%
        `,
        backgroundSize: "calc(100%/3) 50%",
        animation: `${l3} 1s infinite linear`,
      }}
    />
  );
}
